import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {DataService} from "../../service/data.service";
import {PlatformRole} from "../../api/enums";

import {FormsModule} from "@angular/forms";
import {ChartModule} from "primeng/chart";
import {MenuModule} from "primeng/menu";
import {TableModule} from "primeng/table";
import {StyleClassModule} from "primeng/styleclass";
import {PanelMenuModule} from "primeng/panelmenu";
import {ButtonModule} from "primeng/button";
import {AvatarModule} from "primeng/avatar";
import {AvatarGroupModule} from "primeng/avatargroup";
import {ToastModule} from "primeng/toast";
import {BlockUIModule} from "primeng/blockui";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {DividerModule} from "primeng/divider";
import {Subscription} from "rxjs";
import {PlatformUser} from "../../api/db/entities/PlatformUser";

@Component({
    templateUrl: './initial-role-selection-page.component.html',
    imports: [
    FormsModule,
    ChartModule,
    MenuModule,
    TableModule,
    StyleClassModule,
    PanelMenuModule,
    ButtonModule,
    AvatarModule,
    AvatarGroupModule,
    ToastModule,
    BlockUIModule,
    ProgressSpinnerModule,
    DividerModule
]
})
export class InitialRoleSelectionPageComponent implements OnInit, OnDestroy {
    private dataService = inject(DataService);

    private platformUser: PlatformUser;
    processing: boolean = false;

    constructor() {
        const dataService = this.dataService;

        this.subscriptions.push(dataService.userObs.subscribe(u => {
            this.platformUser = u;
            console.log('Startup loading', this.platformUser);
            if (this.platformUser.roles.length !== 0) {
                console.log('Clearing and redirecting from selection screen');
                this.dataService.redirectUrl = null;
                this.dataService.redirectToHome();
            }
        }));
    }
    async ngOnInit() {
    }

    private subscriptions: Subscription[] = [];
    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe())
    }
    async addRoles(newRoles: PlatformRole[]) {
        console.log("Adding Role");
        this.processing = true;
        if (newRoles.includes(PlatformRole.WRITER)) {
            await this.dataService.addWriterRole();
        }
        if (newRoles.includes(PlatformRole.BETAREADER)) {
            await this.dataService.addBetaReaderRole();
        }
        console.log("Disabling processing");
        this.processing = false;
        this.dataService.redirectToHome(true);
    }

    protected readonly PlatformRole = PlatformRole;
}
